/* eslint-disable max-classes-per-file */
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";
import { Destineringsomrade } from "../models/dso-models";

export class DestineringsomradeBaseCommand<T> extends BasicCommand<T> {
    guid: any;

    get primaryKey(): IPrimaryKey<T> {
        return { guid: this.guid };
    }

    constructor(guid: any, typeName: string, groupKey: string, commandtype: CommandType) {
        super(typeName, groupKey, commandtype);
        this.guid = guid;
    }
}

export class CreateDestineringsomradeCommand extends DestineringsomradeBaseCommand<CreateDestineringsomradeCommand> {
    namn: string;
    aktiv: boolean;
    color: string;
    geometri: string;
    handelssortiment: any[];
    mottagningsplatser: any[];

    constructor(destineringsomrade: Destineringsomrade) {
        super(destineringsomrade.guid, "CreateDestineringsomradeCommand", "destineringsomrade", CommandType.Insert);
        this.namn = destineringsomrade.namn?.trim();
        this.aktiv = destineringsomrade.aktiv;
        this.color = destineringsomrade.color;
        this.geometri = destineringsomrade.geometri;
        this.handelssortiment = destineringsomrade.handelssortiment.map(hs => hs.id);
        this.mottagningsplatser = destineringsomrade.mottagningsplatser.map(mp => mp.id);
    }
}

export class UpdateDestineringsomradeCommand extends DestineringsomradeBaseCommand<UpdateDestineringsomradeCommand> {
    namn: string;
    aktiv: boolean;
    color: string;
    geometri: string;
    handelssortiment: any[];
    mottagningsplatser: any[];

    constructor(destineringsomrade: Destineringsomrade) {
        super(destineringsomrade.guid, "UpdateDestineringsomradeCommand", "destineringsomrade", CommandType.Replace);
        this.namn = destineringsomrade.namn?.trim();
        this.aktiv = destineringsomrade.aktiv;
        this.color = destineringsomrade.color;
        this.geometri = destineringsomrade.geometri;
        this.handelssortiment = destineringsomrade.handelssortiment.map(hs => hs.id);
        this.mottagningsplatser = destineringsomrade.mottagningsplatser.map(mp => mp.id);
    }
}

export class DeleteDestineringsomradeCommand extends DestineringsomradeBaseCommand<DeleteDestineringsomradeCommand> {
    constructor(guid: string) {
        super(guid, "DeleteDestineringsomradeCommand", "destineringsomrade", CommandType.Delete);
    }
}
